import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const EmailUnsubscribe = lazy(() => import("@/pages/EmailUnsubscribe"));

export const Route = createFileRoute("/email-unsubscribe")({
  component: EmailUnsubscribe,
});
